import { NgModule } from "@angular/core";
import { AuthCallbackComponent } from './authentication/auth-callback/auth-callback.component';
import { CoreRoutingModule } from './core-routing.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoginComponent } from './authentication/login/login.component';
import { CommonModule } from "@angular/common";
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    declarations: [
        AuthCallbackComponent,
        LoginComponent
    ],

    imports: [
        CoreRoutingModule,
        MatProgressBarModule,
        CommonModule,
        MatButtonModule
    ]
})

export class CoreModule { }